<div [class]="'d-flex'">
  <div
    *ngIf="isEmptyData"
    class="d-flex flex-column flex-fill justify-content-evenly gap-2"
  >
    <div style="color: gray" class="d-flex justify-content-center">
      <svg fill="currentColor" viewBox="0 0 16 16" width="30%">
        <path
          d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
        />
        <path
          d="M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
        />
      </svg>
    </div>
    <div class="h3 text-center fw-semibold" style="color: gray">
      No hay datos disponibles!
    </div>
    <div class="h5 text-center fw-light" style="color: gray">
      No hay datos para mostrarte en este periodo
    </div>
  </div>
  <div *ngIf="!isEmptyData" class="w-100 pt-2 pe-2">
    <ngx-charts-pie-grid
      *ngIf="library == 'NGX-Charts' && type == undefinied"
      [scheme]="colorScheme"
      [results]="ngxCharts$ | async"
      [animations]="false"
      [minWidth]="0"
      [label]="'Total'"
      [designatedTotal]="totalUnits"
    ></ngx-charts-pie-grid>
    <ngx-charts-advanced-pie-chart
      *ngIf="library == 'NGX-Charts' && type == 'advancedPieChart'"
      [scheme]="colorScheme"
      [results]="ngxCharts$ | async"
      [animations]="false"
      [gradient]="true"
    >
    </ngx-charts-advanced-pie-chart>
    <ngx-charts-heat-map
      *ngIf="library == 'NGX-Charts' && type == 'heatMapChart'"
      [scheme]="colorScheme"
      [legend]="false"
      [animations]="false"
      [xAxis]="true"
      [yAxis]="true"
      [results]="ngxCharts$ | async"
    >
    </ngx-charts-heat-map>
    <p-chart
      *ngIf="library == 'chart.js'"
      [type]="type"
      [data]="pCharts$ | async"
      [options]="options"
      width="100%"
      height="100%"
      [style]="{
        maxWidth: 'max-content',
        maxHeight: 'max-content'
      }"
      [responsive]="true"
    ></p-chart>
  </div>
</div>
